module.exports = __webpack_public_path__ + "static/media/iconSectionCommunication.fb059212.svg";